import { subscribeComponentToErrorCode } from '@ferreri/minato-error-handler-react';

import termPrivate from '../../lib/service/term-private.service';
import termPublic from '../../lib/service/term.service';
import { TermNotFoundError } from './TermNotFoundError';
import {
  GetTermAgreementResponse,
  PostTermAgreementParams,
  PostTermAgreementResponse,
  Term,
  TermResponse,
} from './terms.types';

const TERMS = '/v1/terms';
const TERM = (slug: string) => `${TERMS}/${slug}`;
const TERM_AGREEMENT = (slug: string) => `/v1/me/terms/${slug}/agreement`;
const TERM_AGREEMENT_ACCEPT = (slug: string) => `/v1/me/terms/${slug}/accept`;

export async function getTerm(slug: string): Promise<Term> {
  const response = await termPublic.get<TermResponse>(TERM(slug));

  return response.data.term;
}

export async function getTermAgreement(slug: string) {
  const response = await termPrivate.get<GetTermAgreementResponse>(
    TERM_AGREEMENT(slug),
    {
      validateStatus: () => true,
    },
  );

  return response.data;
}

export async function postTermAgreement({
  slug,
  term_version_id,
}: PostTermAgreementParams) {
  const response = await termPrivate.post<PostTermAgreementResponse>(
    TERM_AGREEMENT_ACCEPT(slug),
    {
      term_version_id,
    },
  );

  return response.data;
}

subscribeComponentToErrorCode('TermNotFoundError', TermNotFoundError);
